<div class="font-general">
  <!-- Menu -->
  <app-left-slider></app-left-slider>
  <!-- #Menu -->
  <!-- Main Container -->
  <div class="container-fluid main-container-app">
    <router-outlet></router-outlet>
  </div>
  <app-chat-admin-component></app-chat-admin-component>
</div>
